import axios from "axios";
import moment from 'moment';

const state = {
  adminReport: null,
  customersCount:null,
  adminLogined: false,
  labLogined:false,
  detailpage:false,
  adminKits: null,
  federalHolidays:null,
  pendingKits: null,
  completedKitCount: 0,
  kitsSubTotal: 0,
  customersTotal:0,
  customersSubTotal:0,
  testKitInfo: null,
  testKitAvg: null,
  overDues:{},
  userInfo: null,
  searchstr: null,
  status: "",
  overDueStatus: null,
  OverDueStyle: null,
  problem: null,
  subFilter: 0,
  overloadSub: 0,
  admins: null,
  labOperators: null,
  customers:null,
  analyticsList:[],
  analyticsCount:null,
  analyticsAll:null,
  analyticsParams:null,
  analyticsStatus:null,
  pogination: null,
  adminPogination: null,
  HolidayPagination:null,
  adminPoginationPage: null,
  poginationPage: null,
  date_from: null,
  date_to: null,
  date_from_analytics: null,
  date_to_analytics: null,
  setSortedBy: "desc",
  setOrderBy: "shipped_at",
  setOrderbyLogs: "created_at",
  setSortedByAdmin: "desc",
  payment: "paid",
  customerkit: 0,
  days:30,
  kitStatus: null,
  componentNum:0,
  wooOrder:null,
  wooOrderSearch:null,
  loader:false,
  analyticsFilter : {},
  showAnaltics: false,
  errorMessage: false,
  showSearchAll:false,
  kitType:0,
  filterSalesdata:{},
  filterWooSalesdata:{},
  salesData:{},
  wooSalesData:{},
  UserLogs: null,
  UserLogsPage: null,
  yearFilter:null,
  showMap: false,
  groupByField: '', // '', 'city', 'state', or 'zip'
  cityState:{},
  selectedFilters : {
        rstate: '',
        rcity: '',
  },
  timelineStatus:''
};
const mutations = {
  setTimelineStatus(state, array) {
    state.timelineStatus = array;
  },
  setAnalyticsFilter(state, array) {
    state.analyticsFilter = array;
  },
  setReport(state, report) {
    state.adminReport = report;
  },
  adminLogined(state, boolean) {
    state.adminLogined = boolean;
  },
  setDetails(state, boolean) {
    state.detailpage = boolean;
  },
  labLogined(state, boolean) {
    state.labLogined = boolean;
  },
  setCustomerkit(state, boolean) {
    state.customerkit = boolean;
  },
  setAdminKits(state, array) {
    state.adminKits = array;
  },
  setFederalHolidays(state, array) {
    state.federalHolidays = array;
  },
  setPendingKits(state, array) {
    state.pendingKits = array;
  },
  setCompletedKitCount(state, data) {
    state.completedKitCount = data;
  },
  setCustomersCount(state, data) {
    state.customersCount = data;
  },
  setKitsSubTotal(state, data) {
    state.kitsSubTotal = data;
  },
  setCustomersTotal(state, data) {
    state.customersTotal = data;
  },
  setCustomersSubTotal(state, data) {
    state.customersSubTotal = data;
  },
  setAdmins(state, array) {
    state.admins = array;
  },
  setLabOperators(state, array) {
    state.labOperators = array;
  },
  setUserLogs(state, array) {
    state.UserLogs = array;
  },
  setCustomers(state, array) {
    state.customers = array;
  },
  setAnalyticsList(state, array) {
    state.analyticsList = array;
  },
  setAnalyticsCounts(state, array) {
    state.analyticsCount = array;
  },
  setAnalyticsAll(state, array) {
    state.analyticsAll = array;
  },
  setAnalyticsParams(state, array) {
    state.analyticsParams = array;
  },
  setAnalyticsStatus(state, array) {
    state.analyticsStatus = array;
  },
  setOverDueStatus(state, data) {
    state.overDueStatus = data;
  },
  setOverDueStyle(state, data) {
    state.OverDueStyle = data;
  },
  updateAdminInfo(state, user) {
    let index = state.admins.findIndex(admin => admin.id === user.id);
    state.admins.splice(index, 1, user);
  },
  updateLabOperatorInfo(state, user) {
    let index = state.labOperators.findIndex(labOp => labOp.id === user.id);
    state.labOperators.splice(index, 1, user);
  },
  setTestKitAvg(state, obj) {
    state.testKitAvg = obj;
  },
  setOverDues(state, obj) {
    state.overDues = obj;
  },
  setTestKitInfo(state, obj) {
    state.testKitInfo = obj;
  },
  setUserInfo(state, user) {
    state.userInfo = user;
  },
  serachString(state, str) {
    state.searchstr = str;
  },
  setStatusFilter(state, array) {
    state.status = array.join();
  },
  setPaymentFilter(state, str) {
    state.payment = str;
  },
  setDaysFilter(state, num) {
    state.days = num;
  },
  setProblemFilter(state, data) {
    state.problem = data;
  },
  setOverloadSub(state, data) {
    state.overloadSub = data;
  },
  setSubFilter(state, data) {
    state.subFilter = data;
  },
  clearInfo(state) {
    state.testKitInfo = null;
    state.userInfo = null;
  },
  setPogination(state, obj) {
    state.pogination = obj;
  },
  setUserLogsPage(state, num) {
    state.UserLogsPage = num;
  },
  setHolidayPagination(state, obj) {
    state.Holidaypagination = obj;
  },
  setAdminPogination(state, obj) {
    state.adminPogination = obj;
  },
  setPginationPage(state, num) {
    state.poginationPage = num;
  },
  setAdminPginationPage(state, num) {
    state.adminPoginationPage = num;
  },
  setDateFrom(state, date) {
    state.date_from = date;
  },
  setDateTo(state, date) {
    state.date_to = date;
  },
  setDateFromAnalytics(state, date) {
    state.date_from_analytics = date;
  },
  setDateToAnalytics(state, date) {
    state.date_to_analytics = date;
  },
  setSortedBy(state, data) {
    state.setSortedBy = data;
  },
  setSortedByAdmin(state, data) {
    state.setSortedByAdmin = data;
  },
  setSortedByLogs(state, data) {
    state.setOrderbyLogs = data;
  },
  setOrderBy(state, data) {
    state.setOrderBy = data;
  },
  setKitStatus(state, data) {
    state.kitStatus = data;
  },
  setComponentNum(state, data) {
    state.componentNum = data;  
  },
  setWooOrderData(state, data) {
    state.wooOrder = data;  
  },
  setwooOrderSearchData(state, data) {
    state.wooOrderSearch = data;  
  },
  setLoader(state, data) {
    state.loader = data;  
  },
  setAnaltics(state, boolean) {
    state.showAnaltics = boolean;  
  },
  setErrorMessage(state, data) {
    state.errorMessage = data;  
  },
  setShowSearchAll(state, data) {
    state.showSearchAll = data;  
  },
  setkitType(state, data) {
    state.kitType = data;  
  },
  setFilterSalesdata(state, data) {
    state.filterSalesdata = data;  
  },
  setFilterWooSalesdata(state, data) {
    state.filterWooSalesdata = data;  
  },
  setSalesData(state, boolean) {
    state.salesData = boolean;
  },
  setWooSalesData(state, boolean) {
    state.wooSalesData = boolean;
  },
  setYearFilter(state, data) {
    state.yearFilter = data;
  },
  TOGGLE_MAP(state) {
    state.showMap = !state.showMap;
  },
  SET_SHOW_MAP(state, value) {
    state.showMap = value;
  },
  SET_GROUP_BY(state, field) {
    state.groupByField = field;
  },
  setCityStateFilters(state, data) {
    state.cityState = data;
  },
  SET_SELECTED_STATE(state, payload) {
    state.selectedFilters.rstate = payload;
  },
  SET_SELECTED_CITY(state, payload) {
    state.selectedFilters.rcity = payload;
  }
};

const actions = {
  setYearFilter({ commit }, data) {
    commit("setYearFilter",data);
  },
  setCityState({ commit, state }) {
    let url = `/v1/admin/getCityStateFilters`;
  
    return axios.get(url)
      .then(response => {
        commit("setCityStateFilters", response.data);
      
      })
      .catch(error => {
        console.error('Error fetching sales data:', error);
      });
  },
   toggleMap({ commit }) {
    commit('TOGGLE_MAP');
  },
  setShowMap({ commit }, value) {
    commit('SET_SHOW_MAP', value);
  },
  setkitType({ commit , dispatch}, data) {
    dispatch("setSalesData");
    commit("setkitType",data);
  },
  setSalesSubData({ commit }, data) {
    let url = "/v1/admin/getAmazonSales?";
  
    if (data.year) {
      if(url == "/v1/admin/getAmazonSales?") {
        url += `year=${data.year}`;
      } else {
        url += `&year=${data.year}`;
      }
    }
    if (data.month) {
      if(url == "/v1/admin/getAmazonSales?") {
        url += `month=${data.month}`;
      } else {
        url += `&month=${data.month}`;
      }
    }
    return axios.get(url, data)
      .then(response => {
        // Check if response data exists
        if (!response.data || Object.keys(response.data).length === 0) {
          return;
        }
  
        // Group data by year, month, and type, then calculate the average unit price
        const groupedData = groupSalesData(response.data);
       
        const result = formatGroupedData(groupedData);
        console.log(result)
        // Commit the filtered sales data to Vuex
        commit("setFilterSalesdata", result);
      })
      .catch(error => {
        console.error('Error fetching sales sub-data:', error);
    });
    
  },
  async setSalesData({ commit, state }) {
    let  currentYear = null;
    if(state.days != 5) {
        currentYear = new Date().getFullYear();
    }
    let url = `/v1/admin/getAmazonSales?year=${currentYear}`;

    try {
      const response = await axios.get(url);
      commit("setSalesData", response.data.salesData);
      let sales_data = response.data;
      if(sales_data.type == 'productsData') {
       commit("setFilterSalesdata", []);
       return;
      } 
      // if (!sales_data || sales_data.length === 0) {
      //   commit("setFilterSalesdata", getDefaultSalesData()); // Assign default values
      //   return;
      // }

      //const today = new Date();

      // Filter based on the selected days in state
      // if (state.days) {
      //   const pastDate = new Date(today);
      //   switch (state.days) {
      //     case 30:
      //     case 60:
      //     case 90:
      //       pastDate.setDate(today.getDate() - state.days);
      //       sales_data = sales_data.filter(item => {
      //         const itemDate = new Date(item.start_date);
      //         return itemDate >= pastDate && itemDate <= today;
      //       });
      //       break;
      //     case 1:
      //       sales_data = sales_data.filter(item => item.month >= 1 && item.month <= 3);
      //       break;
      //     case 2:
      //       sales_data = sales_data.filter(item => item.month >= 4 && item.month <= 6);
      //       break;
      //     case 3:
      //       sales_data = sales_data.filter(item => item.month >= 7 && item.month <= 9);
      //       break;
      //     case 4:
      //       sales_data = sales_data.filter(item => item.month >= 10 && item.month <= 12);
      //       break;
      //     case 5:
      //       sales_data = sales_data.filter(item => {
      //         const itemDate = new Date(item.start_date);
      //         return itemDate.getFullYear() === today.getFullYear() && itemDate <= today;
      //       });
      //       break;
      //     case 6: // Today
      //       sales_data = sales_data.filter(item => {
      //         const itemDate = new Date(item.start_date);
      //         return (
      //           itemDate.getDate() === today.getDate() &&
      //           itemDate.getMonth() === today.getMonth() &&
      //           itemDate.getFullYear() === today.getFullYear()
      //         );
      //       });
      //       break;
          
      //     case 7: // This Month
      //       sales_data = sales_data.filter(item => {
      //         const itemDate = new Date(item.start_date);
      //         return (
      //           itemDate.getMonth() === today.getMonth() &&
      //           itemDate.getFullYear() === today.getFullYear()
      //         );
      //       });
      //       break;
        
      //     case 8: // Last Year
      //       sales_data = sales_data.filter(item => {
      //         const itemDate = new Date(item.start_date);
      //         return itemDate.getFullYear() === today.getFullYear() - 1;
      //       });
      //       break;
      //     default:
      //       break;
      //   }
      // }
      const groupedData = groupSalesData(sales_data);
 
      const result = formatGroupedData(groupedData);

      // Commit the filtered and grouped sales data to Vuex
      commit("setFilterSalesdata", result);
    } catch (error) {
      console.error('Error fetching sales data:', error);
    }
  },

  async setDaysFilter({ commit, state, dispatch }, data) {
    commit("setDaysFilter", data);
    const today = new Date();
    let sales_data = state.salesData;
    let woo_sales_data = state.wooSalesData;

    if (woo_sales_data && Object.keys(woo_sales_data).length > 0) {
      //woo_sales_data = filterWooSalesData(woo_sales_data, data, today);
      if (woo_sales_data.type	 == 'productsData') {
        commit("setFilterWooSalesdata", []);
        dispatch('changeDashboardValues');
      } else {
          const wooGroupedData = groupWooSalesData(woo_sales_data);
          const wooResult = formatWooSalesData(wooGroupedData);
          // Commit the filtered and grouped sales_data to Vuex
          commit("setFilterWooSalesdata", wooResult);
          dispatch('changeDashboardValues');
      }
    }

  //   if (sales_data && Object.keys(sales_data).length > 0) {
  //     //sales_data = filterAmazonSalesData(sales_data, data, today);
  //     const groupedData = groupSalesData(sales_data);
  //     const result = formatGroupedData(groupedData);
  //     // Commit the filtered and grouped sales data to Vuex
  //     commit("setFilterSalesdata", result);
  //     dispatch('changeDashboardValues');
  //   }
  },
  setWooSalesData({ commit, state }) {
    let url = `/v1/admin/getWooSales?`;
    if (state.days != 0) {
      const currentYear = new Date().getFullYear();
      if(state.yearFilter != null) {
        url += `year=${state.yearFilter}`;
      } 
    }
    return axios.get(url)
      .then(response => {
        commit("setWooSalesData", response.data);
        const today = new Date();
        let woo_sales_data = response.data;
  
        if (woo_sales_data && Object.keys(woo_sales_data).length > 0) {
          if (woo_sales_data.type	 == 'productsData') {
            commit("setFilterWooSalesdata", []);
          } else {
          const wooGroupedData = groupWooSalesData(woo_sales_data);
          const wooResult = formatWooSalesData(wooGroupedData);
          // Commit the filtered and grouped sales_data to Vuex
          commit("setFilterWooSalesdata", wooResult);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching sales data:', error);
      });
  }, 
  setWooSalesSubData({ commit , state}, data) {
    let url = "/v1/admin/getWooSales?";
    // Construct the URL with parameters
       if (data.year) {
      if(url == "/v1/admin/getWooSales?") {
        url += `year=${data.year}`;
      } else {
        url += `&year=${data.year}`;
      }
    }
    if (data.month) {
      if(url == "/v1/admin/getWooSales?") {
        url += `month=${data.month}`;
      } else {
        url += `&month=${data.month}`;
      }
    }
  
    return axios.get(url, data)
      .then(response => {
        // Check if response data exists
        if (!response.data || Object.keys(response.data).length === 0) {
          return;
        }
        const woo_sales_data = response.data
        if (woo_sales_data.type	 == 'productsData') {
          commit("setFilterWooSalesdata", []);
        } else {
          const wooGroupedData = groupWooSalesData(woo_sales_data);
          const wooResult = formatWooSalesData(wooGroupedData);
          //console.log(wooResult);
          // Commit the filtered and grouped sales_data to Vuex
          commit("setFilterWooSalesdata", wooResult);
        }
      })
      .catch(error => {
        console.error('Error fetching sales sub-data:', error);
    });
  }, 
  setShowSearchAll({ commit }, data) {
    commit("setShowSearchAll",data);
  },
  setAnaltics({ commit }, data) {
    commit("setAnaltics",data);
  },
  setAnalyticsFilter({ commit }, data) {
    commit("setAnalyticsFilter",data);
  },
  setErrorMessage({ commit }, data) {
    commit("setErrorMessage",data);
  },
  setLoader({ commit }, data) {
    commit("setLoader",data);
  },
  setComponentNum({ commit }, data) {
    commit("setComponentNum",data);
  },
  sendNewData({ commit, dispatch }, data) {
    return axios.put(`/v1/admin/testkits/${data.id}`, data.data).then(res => {
      commit("setTestKitInfo", res.data.data.testkit);
      dispatch("sendSearchReq");
      return res.data.data.testkit;
    });
  },
  uploadCsv({ commit }, data) {
    return axios.post(`/v1/testkits/${data.id}/report/upload/csv`, data.data);
  },
  readKitCsv({ commit }, data) {
    return axios.post(`/v1/report/upload/readcsv`, data.data).then( res => {
      return res.data.data;
    });
  },
  wcKitCsv({ commit }, data) {
    return axios.post(`/v1/report/upload/wccsv/${data.source}`, data.data).then( res => {
      return res.data.data;
    });
  },
  uploadKitCsv({ commit }, data) {
    return axios.post(`/v1/report/upload/kitcsv`, data.data).then( res => {
      return res.data.data;
    });
  },
  resendNotification({ commit }, data) {
    return axios.post(`/v1/testkits/${data.kit_id}/resend/latest_notification`, data.data);
  },
  searchIntoUser({ commit }, data) {
    return axios.get(
      `/v1/admin/testkits?search=${data.search}&user_id=${data.id}`
    );
  },
  removeAdmin({ commit }, id) {
    return axios.delete(`/v1/admin/admins/${id}`);
  },
  removeLabOperator({ commit }, id) {
    return axios.delete(`/v1/admin/labOperators/${id}`);
  },
  removeKit({ commit }, id) {
    return axios.delete(`/v1/admin/testkits/${id}`);
  },
  archiveKit({ commit, dispatch }, data) {
    return axios.post("/v1/admin/archive", data).then(res => {
      commit("setAdminKits", res.data.data.testkit_data);
    });
  },
  unArchiveKit({ commit, dispatch }, data) {
    return axios.post("/v1/admin/unArchive", data).then(res => {
      commit("setAdminKits", res.data.data.testkit_data);
    });
  },
  shareStatus({ commit },data) {
    return axios.post("/v1/admin/shareStatus", data).then(res => {
      return res.data;
    });
  },
  removeHoliday({ commit }, id) {
    return axios.delete(`/v1/admin/federalHolidays/${id}`);
  },
  addFederalHolidays({ commit, dispatch},data) {
    return axios.post(`/v1/admin/addfederalHolidays`, data).then(res => {
      commit("setFederalHolidays", res.data.data.data);
      commit("setHolidayPagination", res.data.data.lastPage);
    });
  },
  EditAdmin({ commit }, data) {
    return axios.put(`/v1/admin/admins/${data.id}`, data.form).then(res => {
      commit("updateAdminInfo", res.data.data.user);
    });
  },
  EditLabOperator({ commit }, data) {
    return axios.put(`/v1/admin/labOperators/${data.id}`, data.form).then(res => {
      commit("updateLabOperatorInfo", res.data.data.user);
    });
  },
  saveForwardEmail({ commit }, data) {
    return axios.put(`/v1/admin/saveForwardEmail`, data).then(res => {});
  },
  setAdminPassword({ commit }, data) {
    return axios.put(`/v1/admin/confirm`, data).then(res => {});
  },
  addTestKit({ commit, dispatch }, data) {
    return axios.post("/v1/admin/testkits", data);
  },
  kitexist({ commit, dispatch }, data) {
    return axios.post("/v1/admin/kitexist", data);
  },
  editTestKit({ commit, dispatch }, data) {
    return axios.put(`/v1/admin/testkitsedit/${data.id}`, data);
  },
  fetchUserLogs({ commit, state }) {
    let url = `/v1/admin/userLogs?`;

    const params = new URLSearchParams();

    if (state.UserLogsPage || state.UserLogsPage === 0) {
      params.append("page", state.UserLogsPage);
    } else {
        params.append("page", 1);
    }    
    if (state.perPage) params.append("per_page", state.perPage);
    if (state.setSortedBy) {
        params.append("order_by", state.setOrderbyLogs);
        params.append("sorted_by", state.setSortedByAdmin);
    }
    if (state.email) params.append("email", state.email);
    if (state.kit_id) params.append("kit_id", state.kit_id);
    if (state.log_type) params.append("log_type", state.log_type);
    if (state.response_status) params.append("response_status", state.response_status);
    if (state.user_id) params.append("user_id", state.user_id);
    if (state.searchstr) params.append("search", state.searchstr);

    url += params.toString();

    return axios.get(url)
        .then(res => {
            commit("setUserLogs", res.data.data);
            commit("setUserLogsPage", res.data.lastPage);
        })
        .catch(error => {
            console.error("Error fetching user logs:", error);
        });
  },
  getAdminInfo({ commit, dispatch }) {
    dispatch("sendSearchReq", "per_page=20");
      let type = 'all';
      if (state.kitType == 1) {
        type = 'with'
      } else if (state.kitType == 2) {
        type = 'without'
      }
      const data = {
        payment: state.payment,
        day: state.days,
        type:type
      }
      return axios.post("/v1/admin/dashboard", data).then(res => {
        commit("setReport", res.data.data.report);
        commit("setReport", res.data.data.report);
        commit("adminLogined", true);
        commit("labLogined", false);
      });
  },
  getFederalHolidays({ commit, dispatch}) {
    let url = "/v1/admin/federalHolidays?";
    if (state.HolidayPagination !== null) {
      if (url === "/v1/admin/federalHolidays?") {
        url += `page=${state.HolidayPagination}`;
      } else {
        url += `&page=${state.HolidayPagination}`;
      }
    }
    if (state.setSortedBy !== null) {
      if (url === "/v1/admin/federalHolidays?") {
        url += `order_by=holiday_at&sorted_by=${state.setSortedBy}`;
      } else {
        url += `&order_by=holiday_at&sorted_by=${state.setSortedBy}`;
      }
    }
    commit("setLoader", true);
    return axios.get(url).then(res => {
      commit("setLoader", false);
      commit("setFederalHolidays", res.data.data.data);
      commit("setHolidayPagination", res.data.data.lastPage);
    }).catch(error => {
      commit("setLoader", false);
      commit("setErrorMessage", true);
    });
  },
  getLabOperatorInfo({ commit, dispatch }) {
    commit("adminLogined", true);
    commit("labLogined", true);
  },
  getAdminKits({ commit }, data) {
    return axios.get(`/v1/admin/testkits?${data}`).then(res => {
      commit("setAdminKits", res.data.data.data);
      commit("setPogination", res.data.data.lastPage);
    });
  },
  getPendingKits({ commit }, data) {
    commit("setLoader", true);
    return axios.get(`/v1/admin/pendingkits?${data}`).then(res => {
      commit("setLoader", false);
      commit("setPendingKits", res.data.data.data);
      commit("setPogination", res.data.data.lastPage);
    }).catch(error => {
      commit("setLoader", false);
      commit("setErrorMessage", true);
    });
  },
  setSerachString({ commit }, data) {
    commit("serachString", data);
  },
  testKitInfo({ commit, dispatch }, id) {
    return axios.get(`/v1/admin/testkits/${id}`).then(res => {
      commit("setTestKitInfo", res.data.data.testkit);
    });
  },
  resetKit({ commit, dispatch }, data){
    return axios.get(`/v1/admin/resetKit/${data.id}`).then(res => {
      dispatch("sendSearchReq", "per_page=20");
      return true;
    });
  },
  testKitAvg({ commit, dispatch }) {
    let price_type = 2;
    if(state.payment !== null) { 
      if(state.payment == "paid") {
        price_type = 1;
      }else if(state.payment == "free") {
        price_type = 0;
      }
    }
    let type = 'all';
    if (state.kitType == 1) {
      type = 'with'
    } else if (state.kitType == 2) {
      type = 'without'
    }
    const data_type = {
      payment: state.payment,
      day: state.days,
      type:type
    }
    // axios.post("/v1/admin/dashboard", data_type).then(res => {
    //   commit("setReport", res.data.data.report);
    // });
    const data = {
      payment: price_type,
      day: state.days,
      type:type
    }
    dispatch('overDues');
    return axios.post(`/v1/admin/testkitsavg`,data).then(res => {
      // commit("setOverDues", res.data.data.report);
      commit("setTestKitAvg", res.data.data.testkit);
      commit("setTimelineStatus", res.data.data.status);
    });
  },
  overDues({ commit, dispatch }) {
    let type = 'all';
    if (state.kitType == 1) {
      type = 'with'
    } else if (state.kitType == 2) {
      type = 'without'
    }
    const data = {
      payment: state.payment,
      day: state.days,
      type:type
    }
    
    return axios.post(`/v1/admin/overDues`,data).then(res => {
      commit("setOverDues", res.data.data.count);
    });
  },
  getUserInfo({ commit }, id) {
    return axios.get(`/v1/admin/users/${id}`).then(res => {
      commit("setUserInfo", res.data.data.user);
    });
  },
  setPginationPage({ commit }, data) {
    commit("setPginationPage", data);
  },
  setUserLogsPage({ commit }, data) {
    commit("setUserLogsPage", data);
  },
  setAdminPginationPage({ commit }, data) {
    commit("setAdminPginationPage", data);
  },
  setDateFrom({ commit }, data) {
    commit("setDateFrom", data);
    commit("setPginationPage", null);
  },
  setDateTo({ commit }, data) {
    commit("setDateTo", data);
    commit("setPginationPage", null);
  },
  setCustomerkit({ commit }, data) {
    commit("setCustomerkit", data);
  },
  setCustomerCount({ commit }, data) {
    commit("setCustomersCount", data);
  },
  setDateFromAnalytics({ commit }, data) {
    commit("setDateFromAnalytics", data);
  },
  setDateToAnalytics({ commit }, data) {
    commit("setDateToAnalytics", data);
  },
  setAnalyticsHead({ commit }, data) {
    commit("setAnalyticsStatus", data);
  },
  setOverDueByShipped({ commit }, data) {
    commit("setOverDueStatus", data);
  },
  setOverDueByStyle({ commit }, data) {
    commit("setOverDueStyle", data);
  },
  setSortedByAdmin({ commit }, data) {
    commit("setSortedByAdmin", data);
  },
  setSortedBy({ commit }, data) {
    commit("setSortedBy", data);
  },
  setOrderBy({ commit }, data) {
    commit("setOrderBy", data);
  },
  setSortedByLogs({ commit }, data) {
    commit("setSortedByLogs", data);
  },
  resetState({ commit, getters }) {
    commit("serachString", null);
    commit("setOrderBy", "shipped_at");
    commit("setSortedBy", "desc");
    commit("setStatusFilter", []);
    commit("setProblemFilter", null);
    commit("setSubFilter", null);
    commit("setOverloadSub", null);
    commit("setDateFrom", null);
    commit("setDateToAnalytics", null);
    commit("setDateFromAnalytics", null);
    commit("setDateTo", null);
    commit("setOverDueStatus", null);
  },
  sendSearchReq({ commit, getters }) {
    let url = "per_page=20";
    if (state.kitType !== 0) {
      if (url === "") {
        url += `kitType=${state.kitType}`;
      } else {
        url += `&kitType=${state.kitType}`;
      }
    }
    if (state.searchstr !== null) {
      if (url === "") {
        url += `search=${state.searchstr}`;
      } else {
        url += `&search=${state.searchstr}`;
      }
    }
    if (state.setOrderBy !== null && state.setSortedBy !== null) {
      if (url === "") {
        url += `order_by=${state.setOrderBy}&sorted_by=${state.setSortedBy}`;
      } else {
        url += `&order_by=${state.setOrderBy}&sorted_by=${state.setSortedBy}`;
      }
    }
    if (state.status !== "") {
      if (url === "") {
        url += `status=${state.status}`;
      } else {
        url += `&status=${state.status}`;
      }
    }
    if (state.payment !== "") {
      if (url === "") {
        url += `payment=${state.payment}`;
      } else {
        url += `&payment=${state.payment}`;
      }
    }
    if (state.problem !== null) {

      if (url === "") {
        url += `problem=${state.problem}`;
      } else {
        url += `&problem=${state.problem}`;
      }

      if (state.subFilter !== null) {
        url += `&subfilter=${state.subFilter}`;
      }

      if (state.overloadSub !== null) {
        url += `&overloadSub=${state.overloadSub}`;
      }
    }
    if (state.poginationPage !== null) {
      if (url === "") {
        url += `page=${state.poginationPage}`;
      } else {
        url += `&page=${state.poginationPage}`;
      }
    }
    if (state.date_from !== null) {
      if (url === "") {
        url += `date_from=${state.date_from}`;
      } else {
        url += `&date_from=${state.date_from}`;
      }
    }
    if (state.date_to !== null) {
      if (url === "") {
        url += `date_to=${state.date_to}`;
      } else {
        url += `&date_to=${state.date_to}`;
      }
    }
    if (state.days !== null) {
      if (url === "") {
        url += `days=${state.days}`;
      } else {
        url += `&days=${state.days}`;
      }
    }
    commit("setLoader", true);
    return axios.get(`/v1/admin/testkits?${url}`).then(res => {
      commit("setLoader", false);
      commit("setAdminKits", res.data.data.testkits.data);
      commit("setPendingKits", res.data.data.testkits.data);
      commit("setPogination", res.data.data.testkits.lastPage);
      commit("setCompletedKitCount", res.data.data.total);
      commit("setReport", {total: res.data.data.total});
      commit("setKitsSubTotal", res.data.data.sub_total_count);
      commit("setKitStatus", res.data.data.kit_status);
    }).catch((error) => {
      commit("setLoader", false);
      commit("setErrorMessage", true);
    });
  },
  sendsearchAllReq({ commit, getters }){
    let url = "per_page=20";
    if (state.searchstr !== null) {
      if (url === "") {
        url += `search=${state.searchstr}`;
      } else {
        url += `&search=${state.searchstr}`;
      }
    }

    if (state.setOrderBy !== null && state.setSortedBy !== null) {
      if (url === "") {
        url += `order_by=${state.setOrderBy}&sorted_by=${state.setSortedBy}`;
      } else {
        url += `&order_by=${state.setOrderBy}&sorted_by=${state.setSortedBy}`;
      }
    }

    if (state.poginationPage !== null) {
      if (url === "") {
        url += `page=${state.poginationPage}`;
      } else {
        url += `&page=${state.poginationPage}`;
      }
    }
    commit("setLoader", true);
    return axios.get(`/v1/admin/alltestkits?${url}`).then(res => {
      commit("setLoader", false);
      commit("setAdminKits", res.data.data.testkits.data);
      commit("setPendingKits", res.data.data.testkits.data);
      commit("setPogination", res.data.data.testkits.lastPage);
      commit("setCompletedKitCount", res.data.data.total);
      commit("setReport", {total: res.data.data.total});
      commit("setKitsSubTotal", res.data.data.sub_total_count);
    });
  },

  sendSearchReqAnalytics({ commit, getters }) {
    let url = "/v1/admin/analyticsCount?";
    if (state.selectedFilters.rstate !== null) {
        url += `&state=${state.selectedFilters.rstate}`;
    }
    if (state.selectedFilters.rcity !== null) {
        url += `&city=${state.selectedFilters.rcity}`;
    }
    return axios.get(url).then(res => {
        commit("setAnalyticsCounts", res.data);
    });
  },
  sendSearchReqAnalyticsAll({ commit, getters }) {
    let url = "/v1/admin/analyticsAll?";
    if (state.selectedFilters.rstate !== null) {
        url += `&state=${state.selectedFilters.rstate}`;
    }
    if (state.selectedFilters.rcity !== null) {
        url += `&city=${state.selectedFilters.rcity}`;
    }
    commit("setLoader", true);
    return axios.get(url).then(res => {
        commit("setAnalyticsAll", res.data.data);
        commit("setLoader", false);
    });
  },
  sendSearchReqLab({ commit, getters }) {
    let url = "";
    if (state.searchstr !== null) {
      if (url === "") {
        url += `search=${state.searchstr}`;
      } else {
        url += `&search=${state.searchstr}`;
      }
    }
    return axios.get(`/v1/admin/testkitsLabs?${url}`).then(res => {
      commit("setAdminKits", res.data.data);
    });
},

  sendSearchReqPending({ commit, getters }) {
    let url = "per_page=20";
    if (state.searchstr !== null) {
      if (url === "") {
        url += `search=${state.searchstr}`;
      } else {
        url += `&search=${state.searchstr}`;
      }
    }
    if (state.setSortedBy !== null) {
      if (url === "") {
        url += `order_by=created_at&sorted_by=${state.setSortedBy}`;
      } else {
        url += `&order_by=created_at&sorted_by=${state.setSortedBy}`;
      }
    }
    if (state.status !== "") {
      if (url === "") {
        url += `status=${state.status}`;
      } else {
        url += `&status=${state.status}`;
      }
    }
    if (state.payment !== "") {
      if (url === "") {
        url += `payment=${state.payment}`;
      } else {
        url += `&payment=${state.payment}`;
      }
    }
    if (state.kitType !== 0) {
      if (url === "") {
        url += `kitType=${state.kitType}`;
      } else {
        url += `&kitType=${state.kitType}`;
      }
    }
    if (state.problem !== null) {
      if (url === "") {
        url += `problem=${state.problem}`;
      } else {
        url += `&problem=${state.problem}`;
      }
      if (state.subFilter !== null) {
        url += `&subfilter=${state.subFilter}`;
      }
      if (state.overloadSub !== null) {
        url += `&overloadSub=${state.overloadSub}`;
      }
      
    }
    if (state.poginationPage !== null) {
      if (url === "") {
        url += `page=${state.poginationPage}`;
      } else {
        url += `&page=${state.poginationPage}`;
      }
    }
    if (state.date_from !== null) {
      if (url === "") {
        url += `date_from=${state.date_from}`;
      } else {
        url += `&date_from=${state.date_from}`;
      }
    }
    if (state.date_to !== null) {
      if (url === "") {
        url += `date_to=${state.date_to}`;
      } else {
        url += `&date_to=${state.date_to}`;
      }
    }
    if (state.overDueStatus !== null) {
      if (url === "") {
        url += `overdue=${state.overDueStatus}`;
      } else {
        url += `&overdue=${state.overDueStatus}`;
      }
    }
    if (state.days !== null) {
      if (url === "") {
        url += `day=${state.days}`;
      } else {
        url += `&day=${state.days}`;
      }
    }
    commit("setLoader", true);
    return axios.get(`/v1/admin/pendingkits?${url}`).then(res => {
      commit("setLoader", false);
      commit("setPendingKits", res.data.data.data);
      commit("setPogination", res.data.data.lastPage);
      commit("setCompletedKitCount", res.data.data.total);
      //commit("setReport", {total: res.data.data.total});
      commit("setKitsSubTotal", res.data.data.sub_total_count);
    }).catch(error => {
      // Handle any additional errors or log them
      commit("setLoader", false);
      commit("setErrorMessage", true);
    });
  },

  outlierKitsCsv({ commit, getters }) {
    let url = "per_page=20";
    if (state.searchstr !== null) {
      if (url === "") {
        url += `search=${state.searchstr}`;
      } else {
        url += `&search=${state.searchstr}`;
      }
    }
    if (state.kitType !== 0) {
      if (url === "") {
        url += `kitType=${state.kitType}`;
      } else {
        url += `&kitType=${state.kitType}`;
      }
    }
    if (state.setSortedBy !== null) {
      if (url === "") {
        url += `order_by=created_at&sorted_by=${state.setSortedBy}`;
      } else {
        url += `&order_by=created_at&sorted_by=${state.setSortedBy}`;
      }
    }
    if (state.status !== "") {
      if (url === "") {
        url += `status=${state.status}`;
      } else {
        url += `&status=${state.status}`;
      }
    }
    if (state.payment !== "") {
      if (url === "") {
        url += `payment=${state.payment}`;
      } else {
        url += `&payment=${state.payment}`;
      }
    }
    if (state.problem !== null) {
      if (url === "") {
        url += `problem=${state.problem}`;
      } else {
        url += `&problem=${state.problem}`;
      }
      if (state.subFilter !== null) {
        url += `&subfilter=${state.subFilter}`;
      }
    }
    if (state.poginationPage !== null) {
      if (url === "") {
        url += `page=${state.poginationPage}`;
      } else {
        url += `&page=${state.poginationPage}`;
      }
    }
    if (state.date_from !== null) {
      if (url === "") {
        url += `date_from=${state.date_from}`;
      } else {
        url += `&date_from=${state.date_from}`;
      }
    }
    if (state.date_to !== null) {
      if (url === "") {
        url += `date_to=${state.date_to}`;
      } else {
        url += `&date_to=${state.date_to}`;
      }
    }
    if (state.overDueStatus !== null) {
      if (url === "") {
        url += `overdue=${state.overDueStatus}`;
      } else {
        url += `&overdue=${state.overDueStatus}`;
      }
    }

    if (state.days !== null) {
      if (url === "") {
        url += `day=${state.days}`;
      } else {
        url += `&day=${state.days}`;
      }
    }
    commit("setLoader", true);
    return axios.get(`/v1/admin/outlierKitsCsv?${url}`).then(res => {
      commit("setLoader", false);
      return res;
    }).catch(error => {
      commit("setLoader", false);
      commit("setErrorMessage", true);
    });
  },
  clearInfo({ commit }) {
    commit("clearInfo");
  },
  setStatusFilter({ commit }, array) {
    commit("setStatusFilter", array);
  },
  setPaymentFilter({ commit }, data) {
    commit("setPaymentFilter", data);
  }, 
  setProblemFilter({ commit }, data) {
    commit("setProblemFilter", data);
  },
  setSubFilter({ commit }, data) {
    commit("setSubFilter", data);
  },
  setOverloadSub({ commit }, data) {
    commit("setOverloadSub", data);
  },
  AddAdmin({ commit }, data) {
    return axios.post(`/v1/admin/admins`, data);
  },
  AddLabOperator({ commit }, data) {
    return axios.post(`/v1/admin/labOperators`, data);
  },
  saveUserSubmited({ commit }, data) {
    return axios.post(`/v1/admin/saveUserSubmited`,data).then(res => {
      this.commit("setTestKitInfo", res.data.data.testkit);
      this.commit("setUserInfo", res.data.data.user);
    });
  },
  getAdminInfoList({ commit, dispatch }, data) {
    if (data === "admins") {
      let url = "/v1/admin/admins?";
      if (state.adminPoginationPage !== null) {
        if (url === "/v1/admin/admins?") {
          url += `page=${state.adminPoginationPage}`;
        } else {
          url += `&page=${state.adminPoginationPage}`;
        }
      }
      if (typeof state.searchstr !== 'undefined' &&  state.searchstr !== null) {
        if (url === "/v1/admin/admins?") {
          url += `search=${state.searchstr}`;
        } else {
          url += `&search=${state.searchstr}`;
        }
      }
      if (state.setSortedBy !== null) {
        if (url === "/v1/admin/admins?") {
          url += `order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        } else {
          url += `&order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        }
      }
      commit("setLoader", true);
      return axios.get(url).then(res => {
        commit("setLoader", false);
        commit("setAdmins", res.data.data.data);
        commit("setAdminPogination", res.data.data.lastPage);
      }).catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
    } else {
      return dispatch("sendSearchReq");
    }
  },
  getPendingInfoList({ commit, dispatch }, data) {
    if (data === "pending") {
      let url = "/v1/admin/pendingkits?";
      if (state.adminPoginationPage !== null) {
        if (url === "/v1/admin/pendingkits?") {
          url += `page=${state.adminPoginationPage}`;
        } else {
          url += `&page=${state.adminPoginationPage}`;
        }
      }
      if (state.kitType !== 0) {
        if (url === "/v1/admin/pendingkits?") {
          url += `kitType=${state.kitType}`;
        } else {
          url += `&kitType=${state.kitType}`;
        }
      }
      if (state.setSortedBy !== null) {
        if (url === "/v1/admin/pendingkits?") {
          url += `order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        } else {
          url += `&order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        }
      }

      if (state.status !== "") {
        if (url === "/v1/admin/pendingkits?") {
          url += `status=${state.status}`;
        } else {
          url += `&status=${state.status}`;
        }
      }

      if (state.overDueStatus !== null) {
        if (url === "/v1/admin/pendingkits?") {
          url += `overdue=${state.overDueStatus}`;
        } else {
          url += `&overdue=${state.overDueStatus}`;
        }
      }

      if (state.date_from !== null) {
        if (url === "/v1/admin/pendingkits?") {
          url += `date_from=${state.date_from}`;
        } else {
          url += `&date_from=${state.date_from}`;
        }
      }
      if (state.date_to !== null) {
        if (url === "/v1/admin/pendingkits?") {
          url += `date_to=${state.date_to}`;
        } else {
          url += `&date_to=${state.date_to}`;
        }
      }
      if (state.payment !== null) {
        if (url === "/v1/admin/pendingkits?") {
          url += `payment=${state.payment}`;
        } else {
          url += `&payment=${state.payment}`;
        }
      }
      if (state.days !== null) {
        if (url === "/v1/admin/pendingkits?") {
          url += `day=${state.days}`;
        } else {
          url += `&day=${state.days}`;
        }
      }
      commit("setLoader", true);
      return axios.get(url).then(res => {
        commit("setLoader", false);
        commit("setPendingKits", res.data.data.data);
        commit("setPogination", res.data.data.lastPage);
        
      }).catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
    } else {
      return dispatch("sendSearchReq");
    }
  },
  getLabOperatorInfoList({ commit, dispatch }, data) {
    if (data === "labOps") {
      let url = "/v1/admin/labOperators?";
      if (state.adminPoginationPage !== null) {
        if (url === "/v1/admin/labOperators?") {
          url += `page=${state.adminPoginationPage}`;
        } else {
          url += `&page=${state.adminPoginationPage}`;
        }
      }
      if (typeof state.searchstr !== 'undefined' &&  state.searchstr !== null) {
        if (url === "/v1/admin/labOperators?") {
          url += `search=${state.searchstr}`;
        } else {
          url += `&search=${state.searchstr}`;
        }
      }
      if (state.setSortedBy !== null) {
        if (url === "/v1/admin/labOperators?") {
          url += `order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        } else {
          url += `&order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        }
      }
      commit("setLoader", true);
      return axios.get(url).then(res => {
        commit("setLoader", false);
        commit("setLabOperators", res.data.data.data);
        commit("setAdminPogination", res.data.data.lastPage);
      }).catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
    } else {
      return dispatch("sendSearchReq");
    }
  },
  getContactCustomers({ commit, dispatch }, data) {
      let url = "/v1/Customer/contactCustomer?";
      if (state.searchstr !== null) {
        if (url === "") {
          url += `search=${state.searchstr}`;
        } else {
          url += `&search=${state.searchstr}`;
        }
      }
      if (state.adminPoginationPage !== null) {
        if (url === "/v1/Customer/contactCustomer?") {
          url += `page=${state.adminPoginationPage}`;
        } else {
          url += `&page=${state.adminPoginationPage}`;
        }
      }
      if (state.setSortedBy !== null) {
        if (url === "/v1/Customer/contactCustomer?") {
          url += `order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        } else {
          url += `&order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        }
      }
      if (state.customersCount !== null) {
        if (url === "/v1/Customer/contactCustomer?") {
          url += `count=${state.customersCount}`;
        } else {
          url += `&count=${state.customersCount}`;
        }
      }
      commit("setLoader", true);
      return axios.get(url).then(res => {
        commit("setLoader", false);
        commit("setCustomers", res.data.data.user_details.data);
        commit("setAdminPogination", res.data.data.user_details.lastPage);
        commit("setCustomersTotal", res.data.data.user_details.total);
        commit("setCustomersSubTotal", res.data.data.sub_total_count);
      }).catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
  },
  getCustomersCsv({ commit, dispatch }, data) {
      let url = "/v1/Customer/customerCsv?";
      if (state.searchstr !== null) {
        if (url === "") {
          url += `search=${state.searchstr}`;
        } else {
          url += `&search=${state.searchstr}`;
        }
      }
      if (state.adminPoginationPage !== null) {
        if (url === "/v1/Customer/customerCsv?") {
          url += `page=${state.adminPoginationPage}`;
        } else {
          url += `&page=${state.adminPoginationPage}`;
        }
      }
      if (state.setSortedBy !== null) {
        if (url === "/v1/Customer/customerCsv?") {
          url += `order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        } else {
          url += `&order_by=created_at&sorted_by=${state.setSortedByAdmin}`;
        }
      }
      if (state.customersCount !== null) {
        if (url === "/v1/Customer/customerCsv?") {
          url += `count=${state.customersCount}`;
        } else {
          url += `&count=${state.customersCount}`;
        }
      }
      commit("setLoader", true);
      return axios.get(url).then(res => {
        commit("setLoader", false);
        return res;
      }).catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
  },
  contactCustomer({ commit, dispatch }, data) {
    return axios.post("/v1/lab_operator/contactCustomer", data).then(res => {
      commit("setAdminKits", res.data.data.testkit_data);
    });
  },
  contactCustomerActivated({ commit, dispatch }, data) {
    return axios.post("/v1/lab_operator/contactCustomerActivated", data).then(res => {
      commit("setAdminKits", res.data.data.testkit_data);
    });
  },
  contactAdmin({ commit, dispatch }, data) {
    return axios.post("/v1/lab_operator/contactAdmin", data).then(res => {
    });
  },
  getAnalyticsInfoList({ commit, dispatch }, data){
      let url = `/v1/admin/analyticsList?id=${data.item}&type=${data.type}&per_page=10`;
      if (state.searchstr !== null) {
          url += `&search=${state.searchstr}`;
      }
      if (state.payment !== "") {
          url += `&payment=${state.payment}`;
      }
      if (state.days !== null) {
          url += `&days=${state.days}`;
      }
      if (state.status !== "") {
          url += `&status=${state.status}`;
      }
      if (state.problem !== null) {
        url += `&problem=${state.problem}`;
        if (state.subFilter !== null) {
          url += `&subfilter=${state.subFilter}`;
        }
        if (state.overloadSub !== null) {
          url += `&overloadSub=${state.overloadSub}`;
        }
      }
      if (state.date_from_analytics !== null) {
          url += `&date_from=${state.date_from_analytics}`;
      }
      if (state.date_to_analytics !== null) {
          url += `&date_to=${state.date_to_analytics}`;
      }
      if (state.setSortedByAdmin !== null) {
          url += `&order_by=activated_at&sorted_by=${state.setSortedByAdmin}`;
          commit("setSortedByAdmin", null);
      }
      if (state.setSortedBy !== null) {
        url += `&order_by=result&sorted_by=${state.setSortedBy}`;
        commit("setSortedBy", null);
      }
      if (state.adminPoginationPage !== null) {
         url += `&page=${state.adminPoginationPage}`;
      }
      if (state.selectedFilters.rstate !== null) {
        url += `&state=${state.selectedFilters.rstate}`;
      }
      if (state.selectedFilters.rcity !== null) {
          url += `&city=${state.selectedFilters.rcity}`;
      }
      commit("setAnalyticsParams", data);
      commit("setLoader", true);
      return axios.get(url).then(res => {
        commit("setLoader", false);
        commit("setAnalyticsList", res.data.data.testkits.data);
        commit("setAdminPogination", res.data.data.testkits.lastPage);
      });
  },
  getAnalyticsInfoCsv({ commit, dispatch }, data) {
    let url = `/v1/admin/analyticsListCsv?type=${data.type}`;
    if (state.selectedFilters.rstate !== null) {
        url += `&state=${state.selectedFilters.rstate}`;
    }
    if (state.selectedFilters.rcity !== null) {
        url += `&city=${state.selectedFilters.rcity}`;
    }
    if(data.item) {
        url += `&id=${data.item}`;
    }
     if(data.data_type) {
        url += `&data_type=${data.data_type}`;
    }
    if (state.searchstr !== null) {
        url += `&search=${state.searchstr}`;
    }
    if (state.payment !== "") {
        url += `&payment=${state.payment}`;
    }
    if (state.days !== null) {
        url += `&days=${state.days}`;
    }
    if (state.status !== "") {
        url += `&status=${state.status}`;
    }
    if (state.problem !== null) {
      url += `&problem=${state.problem}`;
      if (state.subFilter !== null) {
        url += `&subfilter=${state.subFilter}`;
      }
      if (state.overloadSub !== null) {
        url += `&overloadSub=${state.overloadSub}`;
      }
    }
    if(state.date_from_analytics !== null) {
      url += `&date_from=${state.date_from_analytics}`;
    }
    if(state.date_to_analytics !== null) {
      url += `&date_to=${state.date_to_analytics}`;
    }
    if(state.setSortedByAdmin !== null) {
      url += `&order_by=activated_at&sorted_by=${state.setSortedByAdmin}`;
      commit("setSortedByAdmin", null);
    }
    if(state.setSortedBy !== null) {
      url += `&order_by=result&sorted_by=${state.setSortedBy}`;
      commit("setSortedBy", null);
    }
    commit("setLoader", true);
    return axios.get(url).then(res => {
      commit("setLoader", false);
      return res;
    }).catch(error => {
      commit("setLoader", false);
      commit("setErrorMessage", true);
    });
  },
  // changeDashboardValues() {
  //   return axios.post(`/v1/admin/labOperators`, data);
  // },
  changeDashboardValues({ commit, dispatch }) {
    // if(state.payment !== 'both') {
      let type = 'all';
      if (state.kitType == 1) {
        type = 'with'
      } else if (state.kitType == 2) {
        type = 'without'
      }
      const data = {
        payment: state.payment,
        day: state.days,
        type:type
      }

      return axios.post("/v1/admin/dashboard", data).then(res => {
        commit("setReport", res.data.data.report);
        commit("setTimelineStatus", res.data.data.report);
        commit("adminLogined", true);
      });
    // }else{
    //   return axios.get("/v1/admin/dashboard").then(res => {
    //     commit("setReport", res.data.data.report);
    //     commit("adminLogined", true);
    //   });
    // }
},
  RefreshTestkits({ commit,dispatch }, data) {
    return axios.get( `/v1/admin/dashboard/refreshTestkits`).then(res => {
      let price_type = null;
      if(state.payment !== null) { 
        if(state.payment == "paid") {
          price_type = 1;
        }else if(state.payment == "free") {
          price_type = 0;
        }
      }
      let data_status = {'shipped_count':0,
                  'delivered_count':0,
                  'activated_count':0,
                  'awaiting_count':0,
                  'received_count':0,
                  'completed_total':0,
                  'total':0};
      res.data.data.testkitRefreshCount.forEach(element => {
        if(element.type == 'status' && element.price_type == price_type && element.days == state.days) {
          dispatch("changeDashboardValues");
        }
        if(element.type == 'over_due' && element.price_type == price_type && element.days == state.days) {
          data_status = {'shipped_count':element.shipped,
                    'delivered_count':element.delivered,
                    'activated_count':element.activated,
                    'awaiting_count':element.lab_awaiting,
                    'received_count':element.lab_received,
                    'completed_total':element.analysis_completed,
                    'total':element.total,
                    'last_run_date':element.last_run_date,
                  };
          commit("setOverDues", data_status);
        }
      });
    });
  },
  getTestkitsCsv({ commit, getters }) {
    let url = "";
    if (state.searchstr !== null) {
      if (url === "") {
        url += `search=${state.searchstr}`;
      } else {
        url += `&search=${state.searchstr}`;
      }
    }
    if (state.kitType !== 0) {
      if (url === "") {
        url += `kitType=${state.kitType}`;
      } else {
        url += `&kitType=${state.kitType}`;
      }
    }
    if (state.setOrderBy !== null && state.setSortedBy !== null) {
      if (url === "") {
        url += `order_by=${state.setOrderBy}&sorted_by=${state.setSortedBy}`;
      } else {
        url += `&order_by=${state.setOrderBy}&sorted_by=${state.setSortedBy}`;
      }
    }
    if (state.status !== "") {
      if (url === "") {
        url += `status=${state.status}`;
      } else {
        url += `&status=${state.status}`;
      }
    }
    if (state.payment !== "") {
      if (url === "") {
        url += `payment=${state.payment}`;
      } else {
        url += `&payment=${state.payment}`;
      }
    }
    if (state.problem !== null) {
      if (url === "") {
        url += `problem=${state.problem}`;
      } else {
        url += `&problem=${state.problem}`;
      }
      if (state.subFilter !== null) {
        url += `&subfilter=${state.subFilter}`;
      }
      
      if (state.overloadSub !== null) {
        url += `&overloadSub=${state.overloadSub}`;
      }
    }
    if (state.date_from !== null) {
      if (url === "") {
        url += `date_from=${state.date_from}`;
      } else {
        url += `&date_from=${state.date_from}`;
      }
    }
    if (state.date_to !== null) {
      if (url === "") {
        url += `date_to=${state.date_to}`;
      } else {
        url += `&date_to=${state.date_to}`;
      }
    }

    if (state.days !== null) {
      if (url === "") {
        url += `days=${state.days}`;
      } else {
        url += `&days=${state.days}`;
      }
    }
    commit("setLoader", true);    
    if(state.showSearchAll){
      return axios.get(`/v1/admin/allTestkitsCsv?${url}`).then(res => {
        commit("setLoader", false);
        return res;
      }).catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
    } else {
      return axios.get(`/v1/admin/testkitsCsv?${url}`).then(res => {
        commit("setLoader", false);
        return res;
      }).catch(error => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
    }
  },
  getWooOrders({ commit }){
    let price_type = null;
    if(state.payment !== null) { 
      if(state.payment == "paid") {
        price_type = 1;
      }else if(state.payment == "free") {
        price_type = 0;
      }
    }
       if (state.date_from !== null) {
      if (url === "") {
        url += `date_from=${state.date_from}`;
      } else {
        url += `&date_from=${state.date_from}`;
      }
    }
    if (state.date_to !== null) {
      if (url === "") {
        url += `date_to=${state.date_to}`;
      } else {
        url += `&date_to=${state.date_to}`;
      }
    }
    const data = {
      price_type,
      day: state.days,
    }
      commit("setLoader", true);
      return axios.post(`/v1/admin/wooOrders`,data).then(res => {
        commit("setLoader", false);
        commit("setWooOrderData", res.data.data.data);
        commit("setwooOrderSearchData", res.data.data.data);
        commit("setPogination", res.data.data.lastPage);
      }).catch((error) => {
        commit("setLoader", false);
        commit("setErrorMessage", true);
      });
  },
  async setWooOrdersData({ commit, state }) {
    
    let data = state.wooOrder;
    if (state.date_from !== null) {
      data = data.filter(item => {
        const fromDate = new Date(state.date_from); 
        const date = new Date(item.date_created); 
        return date >= fromDate;
      });
    }
    if (state.date_to !== null) {
      data = data.filter(item => {
        const toDate  = new Date(state.date_to); 
        const date = new Date(item.date_created); 
        return date <= toDate;
      });
    }
    if (state.searchstr != null && state.searchstr != "") {
      const searchTerm = state.searchstr.toString().toLowerCase(); // Convert search term to lowercase string
      data = data.filter(item => {
        // Check if user_email includes the search term or if id is equal to the search term
        return item.user_email.toLowerCase().includes(searchTerm) || item.id.toString().includes(searchTerm);
      });
    }

    data.sort((a, b) => {
      const dateA = new Date(a.date_created);
      const dateB = new Date(b.date_created);
      if (state.setSortedBy === 'asc') {
        return dateA - dateB; // Ascending order
      } else if (state.setSortedBy === 'desc') {
        return dateB - dateA; // Descending order
      }
    });
  
    const itemsPerPage = 10;
    const lastPage = Math.ceil(data.length / itemsPerPage);
  
    commit("setPogination", lastPage);
    commit("setwooOrderSearchData", data);
  }
};

const getters = {
  adminReport() {
    return state.adminReport;
  },
  customersCount() {
    return state.customersCount;
  },
  adminLogin() {
    return state.adminLogined;
  },
  labLogin() {
    return state.labLogined;
  },
  getAdminKits() {
    return state.adminKits;
  },
  getPendingKits() {
    return state.pendingKits;
  },
  completedKitCount() {
    return state.completedKitCount;
  },
  kitsSubTotal() {
    return state.kitsSubTotal;
  },
  customersTotal() {
    return state.customersTotal;
  },
  customersSubTotal() {
    return state.customersSubTotal;
  },
  getTestKitInfo() {
    return state.testKitInfo;
  },
  getTestKitAvg() {
    return state.testKitAvg;
  },
  getOverDues() {
    return state.overDues;
  },
  getAdminUserInfo() {
    return state.userInfo;
  },
  getAdmins() {
    return state.admins;
  },
  getLabOperators() {
    return state.labOperators;
  },
  getCustomers(){
    return state.customers;
  },
  getAnalyticsList() {
    return state.analyticsList;
  },
  getAnalyticsCounts() {
    return state.analyticsCount;
  },
  getAnalyticsAll() {
    return state.analyticsAll;
  },
  pogination() {
    return state.pogination;
  },
  UserLogsPage() {
    return state.UserLogsPage;
  },
  HolidayPagination() {
    return state.HolidayPagination;
  },
  adminPogination() {
    return state.adminPogination;
  },
  getSearchString() {
    return state.searchstr;
  },
  getAnalyticsStatus() {
    return state.analyticsStatus;
  },
  getAnalyticsParams() {
    return state.analyticsParams;
  },
  getDetails() {
    return state.detailpage;
  },
  getSubFilterStatus() {
    return state.subFilter;
  },
  getOverloadSubStatus() {
    return state.overloadSub;
  },
  problematicKitStatus() {
    return state.problem;
  },
  getPaymentFilter() {
    return state.payment;
  },
  getCustomerkit() {
    return state.customerkit;
  },
  getOverDueStyle() {
    return state.OverDueStyle;
  },
  FederalHolidays() {
    return state.federalHolidays;
  },
  getKitStatus() {
    return state.kitStatus;
  },
  getComponentNum() {
    return state.componentNum;
  },
  getWooOrder() {
    return state.wooOrder;
  },
  getWooOrderSearch() {
    return state.wooOrderSearch;
  },
  getLoader(){
    return state.loader;
  },
  getAnalyticsFilter(){
    return state.analyticsFilter;
  },
  getStatus() {
    return state.status;
  },
  getDateFromAnalytics() {
    return state.date_from_analytics;
  },
  getDateToAnalytics() {
    return state.date_to_analytics;
  },
  getShowAnaltics() {
    return state.showAnaltics;
  },
  getSearchstr(){
    return state.searchstr;
  },
  getErrorMessage(){
    return state.errorMessage;
  },
  getDateTo() {
    return state.date_to ;
  },
  getUserLogs() {
    return state.UserLogs;
  },
  getDateFrom() {
    return state.date_from ;
  },
  getDateFromAnalytics() {
    return state.date_from_analytics ;
  },
  getDateToAnalytics() {
    return state.date_to_analytics ;
  },
  getStatusFilter(){
    return  state.status;
  },
  getFilterSalesdata(){
    return  state.filterSalesdata;
  },
  getFilterWooSalesdata(){
    return  state.filterWooSalesdata;
  },
  getSalesData () {
    return state.salesData;
  },
  getDays(){
    return state.days;
  },
  getkitType() {
    return state.kitType;
  },
  getOverDueStatus () {
    return state.overDueStatus ;
  },
  isMapVisible: (state) => state.showMap,
  getGroupByField: (state) => state.groupByField,
  getCityStateFilters: (state) => state.cityState,
  getCity: (state) => state.selectedFilters.rcity,
  getState: (state) => state.selectedFilters.rstate,
  getTimelineStatus: (state) => state.timelineStatus,
};

// Helper Functions
function groupSalesData(sales_data) {
  if (sales_data.type	 == 'productsData') {
    return sales_data.productsData.reduce((acc, item) => {
      const date = moment(); // Use current date for default grouping
      const year = date.year();
      const month = date.month() + 1;
      const key = `${item.type}-${year}-${month}`;

      acc[key] = {
        year: year,
        month: month,
        type: item.type,
        average_unit_price_amount: 0,
        total_sales_amount: 0,
        order_count: 0,
        order_item_count: 0,
        unit_count: 0,
        count: 0
      };

      return acc;
    }, {});
  } else {
    return sales_data.salesData.reduce((acc, item) => {
      const itemDate = new Date(item.start_date);
      const year = itemDate.getFullYear();
      const month = itemDate.getMonth() + 1; // months are 0-indexed in JS
      const type = item.type;

      const key = `${year}-${type}`;
      if (!acc[key]) {
        acc[key] = {
          year: year,
          month: month,
          type: item.type,
          average_unit_price_amount: 0,
          total_sales_amount: 0,
          order_count: 0,
          order_item_count: 0,
          unit_count: 0,
          count: 0
        };
      }
      acc[key].average_unit_price_amount += parseFloat(item.average_unit_price_amount) || 0;
      acc[key].total_sales_amount += parseFloat(item.total_sales_amount) || 0;
      acc[key].order_count += Number(item.order_count) || 0;
      acc[key].order_item_count += Number(item.order_item_count) || 0;
      acc[key].unit_count += Number(item.unit_count) || 0;
      acc[key].count += 1;
      return acc;
    }, {});
  }
}
function formatGroupedData(groupedData) {
  return Object.values(groupedData).map(item => ({
    year: item.year,
    month: item.month,
    type: item.type,
    average_unit_price_amount: item.count > 0
    ? (item.average_unit_price_amount / item.count).toFixed(2)
    : '0.00',
    total_sales_amount: item.total_sales_amount.toFixed(2),
    order_item_count: item.order_item_count,
    order_count: item.order_count,
    unit_count: item.unit_count,
  }));
}

function groupWooSalesData(woo_sales_data) {
  if (woo_sales_data.type	 == 'productsData') {
    return woo_sales_data.productsData.reduce((acc, item) => {
      const date = moment(); // Use current date for default grouping
      const year = date.year();
      const month = date.month() + 1;
      const key = `${item.type}-${year}-${month}`;

      acc[key] = {
        product_id: item.product_id,
        type: item.type,
        product_name: item.product_name,
        year,
        month,
        date_min: date.toISOString(),
        total_quantity: 0,
        total_sales_amount: 0,
      };

      return acc;
    }, {});
  } else {
    return woo_sales_data.salesData.reduce((acc, item) => {
      const itemDate = moment(item.start_date); // Use moment for date parsing
      let year = itemDate.year();
      const month = itemDate.month() + 1;
      const type = item.type;
      if(!item.hasOwnProperty('quantity')){
        item.quantity = 0;
        item.product_price = 0.00;
      }

      const key = `${type}-${year}-${month}`;
      if (!acc[key]) {
        acc[key] = {
          product_id: item.product_id || 0,
          type: item.type,
          product_name: item.product_name,
          date_min: item.date_min,
          year: year,
          month: month,
          total_quantity: 0,
          total_sales_amount: 0,
        };
      }

      acc[key].total_quantity += Number(item.quantity) || 0;
      acc[key].total_sales_amount += parseFloat(item.product_price)|| 0;
      return acc;
    }, {});
  }
}

function formatWooSalesData(wooGroupedData) {
  return Object.values(wooGroupedData).map(item => ({
    product_id: item.product_id,
    product_name: item.product_name,
    date_min: item.date_min,
    year: item.year,
    type: item.type,
    month: item.month,
    total_quantity: item.total_quantity,
    total_sales_amount: item.total_sales_amount.toFixed(2),
  }));
}
function filterAmazonSalesData(sales_data, filterType, today) {
  let pastDate = new Date(today);
  switch (filterType) {
    case 30:
    case 60:
    case 90:
      pastDate.setDate(today.getDate() - filterType);
      return sales_data.filter(item => {
        const itemDate = new Date(item.start_date);
        return itemDate >= pastDate && itemDate <= today;
      });
    case 1:
      return sales_data.filter(item => item.month >= 1 && item.month <= 3 && state.yearFilter == item.year); // Jan to Mar
    case 2:
      return sales_data.filter(item => item.month >= 4 && item.month <= 6 && state.yearFilter == item.year); // Apr to Jun
    case 3:
      return sales_data.filter(item => item.month >= 7 && item.month <= 9 && state.yearFilter == item.year); // Jul to Sep
    case 4:
      return sales_data.filter(item => item.month >= 10 && item.month <= 12 && state.yearFilter == item.year); // Oct to Dec
    case 5:
      return sales_data.filter(item => {
        const itemDate = new Date(item.start_date);
        return itemDate.getFullYear() === today.getFullYear() && itemDate <= today;
      });
    case 6: // Today
      pastDate.setDate(today.getDate() - 1);
        return sales_data.filter(item => {
          const itemDate = new Date(item.start_date);
          return itemDate >= pastDate && itemDate <= today;
        });
    case 7: // This Month
      pastDate.setDate(today.getDate() - 7);
        return sales_data.filter(item => {
          const itemDate = new Date(item.start_date);
          return itemDate >= pastDate && itemDate <= today;
        });
    default:
      return sales_data;
  }
}

function filterWooSalesData(woo_sales_data, filterType, today) {
  //console.log(woo_sales_data);
  let pastDate = new Date(today);
  switch (filterType) {
    case 30:
    case 60:
    case 90:
      pastDate.setDate(today.getDate() - filterType);
      return woo_sales_data.filter(item => {
        const itemDate = new Date(item.date_min);
        return itemDate >= pastDate && itemDate <= today;
      });
    case 1:
      return woo_sales_data.filter(item => {
        const itemDate = new Date(item.date_min);
        return itemDate.getMonth() >= 0 && itemDate.getMonth() <= 2 && state.yearFilter == item.year; // Jan to Mar
      });
    case 2:
      return woo_sales_data.filter(item => {
        const itemDate = new Date(item.date_min);
        return itemDate.getMonth() >= 3 && itemDate.getMonth() <= 5 && state.yearFilter == item.year; // Apr to Jun
      });
    case 3:
      return woo_sales_data.filter(item => {
        const itemDate = new Date(item.date_min);
        return itemDate.getMonth() >= 6 && itemDate.getMonth() <= 8 && state.yearFilter == item.year; // Jul to Sep
      });
    case 4:
      return woo_sales_data.filter(item => {
        const itemDate = new Date(item.date_min);
        return itemDate.getMonth() >= 9 && itemDate.getMonth() <= 11 && state.yearFilter == item.year; // Oct to Dec
      });
    case 5:
      return woo_sales_data.filter(item => {
        const itemDate = new Date(item.date_min);
        return itemDate.getFullYear() === today.getFullYear() && itemDate <= today;
      });
    case 6: // Today
        pastDate.setDate(today.getDate() - 1);
          return woo_sales_data.filter(item => {
            const itemDate = new Date(item.date_min);
            return itemDate >= pastDate && itemDate <= today;
          });
    case 7: // This Month
      pastDate.setDate(today.getDate() - 7);
        return woo_sales_data.filter(item => {
          const itemDate = new Date(item.date_min);
          return itemDate >= pastDate && itemDate <= today;
        });
    default:
      return woo_sales_data;
  }
}
export default {
  state,
  mutations,
  actions,
  getters
};
